import { groupQuestionsByDependencies } from "../hooks/useQuery/useGetQuestionsBySurveyId/utils/groupQuestionsByDependencies";
import { QuestionWithConditionResult, QuestionWithDependents } from "../hooks/useQuery/useGetQuestionsBySurveyId";

export function groupInvalidatedQuestions(
    invalidQuestions: QuestionWithConditionResult[],
    allQuestions: QuestionWithConditionResult[]
): QuestionWithDependents[] {
    if (invalidQuestions.length === 0) {
        return [];
    }

    // Get the full dependency graph first
    const fullGroupedQuestions = groupQuestionsByDependencies(allQuestions);
    const invalidQuestionIds = new Set(invalidQuestions.map(q => q.id));

    // Extract and build mini-trees for only the invalid questions

    // Recursive function to extract relevant parts of the tree
    function extractRelevantBranches(
        questions: QuestionWithDependents[],
        targetIds: Set<string>
    ): QuestionWithDependents[] {
        const result: QuestionWithDependents[] = [];

        for (const question of questions) {
            // Check if this question or any of its dependents are in our target set
            const isRelevant = targetIds.has(question.id);
            const relevantDependents = extractRelevantBranches(question.dependent_questions, targetIds);

            if (isRelevant || relevantDependents.length > 0) {
                result.push({
                    ...question,
                    dependent_questions: relevantDependents
                });
            }
        }

        return result;
    }

    return extractRelevantBranches(fullGroupedQuestions, invalidQuestionIds);
}